import type { DirectDealsConfig } from '@openx/components-direct-deals/lib/utils/context/types.ts';
import { useDirectDealsContact } from './utils/useDirectDealsContact.ts';
import { useDirectDealsDetailsFetch } from './utils/useDirectDealsDetailsFetch.ts';
import { useDirectDealsList } from './utils/useDirectDealsList.ts';
import { useDirectDealsListFetch } from './utils/useDirectDealsListFetch.ts';

export const directDealsConfig: DirectDealsConfig = {
  useDirectDealsListFetch,
  useDirectDealsList,
  useDirectDealsDetailsFetch,
  useDirectDealsContact,
};
